export const pluralize = (
  count: number,
  singular: string,
  plural: string
): string => {
  if (count === 1) {
    return singular;
  }

  return plural;
};

export const bytesToMegabytes = (bytes: number): number => {
  return bytes / 1024 / 1024;
};

export const downloadFile = async (response: Response, filename: string) => {
  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
};

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const noop = () => {};
